export function pageRangeText(pageIndex, pageSize, total) {
  if (!total) {
    return "";
  }
  const start = pageIndex * pageSize + 1;
  const end = Math.min((pageIndex + 1) * pageSize, total);
  return `Showing ${start}–${end} of ${total}`;
}
